import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { BehaviorSubject, Observable, Subject, Subscription, firstValueFrom, take, timer } from 'rxjs';
import { Router } from '@angular/router';
import { DASHBOARD, LOGIN } from 'src/app/constants/routes';
import { PROFILE_DETAIL, USER_INFO_API } from 'src/app/constants/api-end-points';
import { email, userId, } from 'src/app/constants/storage-keys';
import { ApiResponse } from 'src/app/constants/interfaces';
import { ToastService } from 'src/app/components/toast-notification/toast.service';
import { CommonService } from '../common/common.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private logoutTimer: Observable<number>;
  profileDetail: any;
  profileData = new Subject<any>();
  private isLoggedInSubject = new BehaviorSubject<boolean>(false);
  public isLoggedIn$: Observable<boolean> = this.isLoggedInSubject.asObservable();

  private logoutTimerSubscription: Subscription;
  logoutTime = 4 * 60 * 60 * 1000; // 4hrs  in milliseconds

  constructor(private _http: HttpService, private _router: Router, private _toast: ToastService,private _common:CommonService) {
    this.initLogoutTimer();

  }

  setUserToken(token: any) {
    localStorage.setItem("session_token", token);
  }

  get token() {
    return localStorage.getItem("session_token");
  }

  get userId() {
    return atob(localStorage.getItem(userId));
  }

  logout() {
    localStorage.removeItem(email);
    localStorage.removeItem('session_token');
    // localStorage.clear();
    setTimeout(() => {
      this.profileDetail = null;
    }, 1000); // this is used for avoid random reflection on side bar if logout
    this._router.navigate([LOGIN.fullUrl]);
    this.isLoggedInSubject.next(false);

    // Unsubscribe from the timer if user logs out manually
    if (this.logoutTimerSubscription) {
      this.logoutTimerSubscription.unsubscribe();
    }

  }

  async loginSuccessfully(response: any, responeFrom = "") {
    const data = response.result;
    this.setUserToken(data.accessToken);
    localStorage.setItem(userId, btoa(data._id));
    this._router.navigate([DASHBOARD.fullUrl]);
    this._toast.success(response.message);
    this.isLoggedInSubject.next(true);
    this.resetLogoutTimer();
  }

  initLogoutTimer() {
    // Unsubscribe from any existing timer to avoid multiple instances
    if (this.logoutTimerSubscription) {
      this.logoutTimerSubscription.unsubscribe();
    }
    this.logoutTimerSubscription = timer(this.logoutTime).pipe(take(1)).subscribe(() => {
      this._common.canPageLeave$.next(true);
      this.logout();
      this._toast.error('Session Expired!');
    });
  }

  resetLogoutTimer() {
    // Reset the timer by re-initializing it
    this.initLogoutTimer();
  }


  getProfileDetail(showLoader = true) {
    return new Promise((resolve, reject) => {
      if (this.profileDetail) {
        resolve(this.profileDetail);
      } else {

        firstValueFrom(this._http
          .get(PROFILE_DETAIL))
          .then(
            (response: any) => {
              if (response?.result?.status === "blocked") {
                this.logout();
                reject();
              }

              this.profileDetail = response.result;
              resolve(this.profileDetail);
            },
            (error) => {
              reject(error);
              this.logout();

            }
          )
          .catch((error) => {
            this.logout();
          });
      }
    });
  }

  async updateProfileDetails(showLoader = true) {
    try {
      const updatedProfile: ApiResponse<any> = await firstValueFrom(
        this._http.get(USER_INFO_API, "", showLoader)
      );
      if (updatedProfile.data.status === "blocked") {
        this.logout();
      }
      if (updatedProfile.status == 200) {
        this.profileDetail = updatedProfile.data;
      }
    } catch (error) {
      this.logout();
    }
  }

  attachDeviceToken() {
    return (Date.now() + Math.floor(Math.random() * 1000000) + 1).toString();
  }

  randomDeviceId() {
    return window.navigator.userAgent.replace(/\D+/g, "");
  }

  getTimeZone() {
    let date = new Date();
    let offset = date.getTimezoneOffset() * -1;
    return offset * 60 * 1000;
  }


}
